import { render } from "./esteghdamresult.vue?vue&type=template&id=6cc9a7e7"
import script from "./esteghdamresult.vue?vue&type=script&lang=js"
export * from "./esteghdamresult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/redpoint-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__